import { useState } from 'react';
import { PiFilesFill } from 'react-icons/pi';
import { VscAccount } from 'react-icons/vsc';
import { useNavigate } from 'react-router-dom';
import { UserData } from '../../../hooks/useUsers';
import FilesDialog from '../FilesDialog/FilesDialog';

const lastLoginDateFormatter = new Intl.DateTimeFormat('pl-PL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const formatLastLoginDate = (dateString: string) => {
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return dateString;
  }

  return lastLoginDateFormatter.format(date);
};

export default function UserListItem({
  id,
  username,
  first_name,
  last_name,
  email,
  role,
  is_active,
  profile_image,
  last_login_date,
}: UserData) {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);

  const profileButton = () => {
    navigate('/admin/user/profile', {
      state: {
        id,
        username,
        first_name,
        last_name,
        email,
        role,
        is_active,
        profile_image,
      },
    });
  };

  const dddFilesButton = () => {
    setDialogOpen(true);
  };

  const formattedLastLoginDate = last_login_date
    ? formatLastLoginDate(last_login_date)
    : '';

  return (
    <>
      <div className="grid grid-cols-1 gap-4 border-b border-slate-150 px-4 py-4 last:border-none dark:border-navy-500 md:grid-cols-[minmax(0,2.2fr)_minmax(140px,1fr)_minmax(140px,1fr)_minmax(220px,1.2fr)] sm:px-5">
        <div className="whitespace-nowrap">
          <div className="flex items-center gap-3">
            <div className="avatar size-12">
              <img className="rounded-lg" src={profile_image} alt="avatar" />
            </div>
            <div>
              <div className="font-medium text-slate-700 dark:text-navy-100">
                {first_name ? first_name : ' '} {last_name}
              </div>
              <div className="text-xs text-slate-400 dark:text-navy-300">
                {username}
              </div>
              {formattedLastLoginDate ? (
                <div className="text-xs text-slate-400 dark:text-navy-300">
                  Ostatnie logowanie: {formattedLastLoginDate}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="flex items-center whitespace-nowrap text-slate-700 dark:text-navy-100">
          {role === 'User' ? 'Użytkownik' : 'Administrator'}
        </div>
        <div className="flex items-center whitespace-nowrap">
          <span
            className={`rounded-full px-3 py-1 text-xs font-medium text-white ${
              is_active ? 'bg-success' : 'bg-error'
            }`}>
            {is_active ? 'Aktywny' : 'Nieaktywny'}
          </span>
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <button
              className="btn h-9 space-x-2 bg-primary px-3 font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90"
              onClick={profileButton}>
              <VscAccount />
              <span>Profil</span>
            </button>
            <button
              className="btn h-9 space-x-2 bg-slate-150 px-3 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80 dark:bg-navy-500 dark:text-navy-50 dark:hover:bg-navy-450 dark:focus:bg-navy-450 dark:active:bg-navy-450/90"
              onClick={dddFilesButton}>
              <PiFilesFill />
              <span>Pliki DDD</span>
            </button>
          </div>
        </div>
      </div>

      <FilesDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        email={email}
      />
    </>
  );
}
